module.exports = __webpack_public_path__ + "static/media/github.8dc66f6f.svg";